<template>
    <div>
        <div v-if="groups.length > 0" class="group-slider grid col-4 col-gap-3 sm-col-2 row-gap-1 tw-relative" :class="{'compact': compact}">
            <a :href="'/groups/' + group.slug" class="group-slider-item tw-flex tw-flex-col tw-justify-end tw-relative tw-cursor-pointer" v-for="group in groups" :key="group.id">
                <img :src="`${ group.image }?width=406`" :alt="group.name + ' image'">
                <div class="tw-z-10">
                    <span class="tiny-text">
                    <i class="far fa-users tw-pr-1"></i>
                    {{ group.members_count }}
                </span>
                    <h3 class="tw-text-white tw-px-4 tw-py-3 tw-leading-relaxed" v-text="group.name"></h3>
                </div>
            </a>
            <a href="/groups" class="discover-more-btn secondary-c-bg secondary-c-contrast tw-rounded-full tw-flex tw-items-center tw-justify-center tw-cursor-pointer" v-if="groups.length >= 4">
                <i class="fa fa-search"></i>
            </a>
        </div>
    </div>
</template>

<script>
    import Global from '../../mixins/Global';
	import Plans from '../../mixins/v2/Plans';
    import { mapState } from 'vuex';

    export default {
        name: 'GroupsSlider',

        mixins: [ Global, Plans ],

        data() {
            return {
                groups: [],
            };
        },

        computed: {
            ...mapState([
                'displayMode',
            ]),

            compact() {
                return this.displayMode === 'small' && !isHelpdesk;
            },
        },

        methods: {
            fetchRecentGroups() {
                // get groups with recent activity
                const my_groups_url = `/api/v3/groups?order_by=updated_at&where_dh=members:user_id:${this.user.id}&size=4`;

                axios.get(my_groups_url).then((groups) => {
                    this.groups = groups.data.data;
                });
            },
        },

        created() {
			if (this.plugins.groups && this.hasPlan(8)) {
				this.fetchRecentGroups();
			}
		},
    };
</script>

<style lang="scss" scoped>
    .group-slider {
        margin-bottom: 20px;

        .discover-more-btn {
            width: 40px;
            height: 40px;
            position: absolute;
            right: -20px;
            top: 80px;
            z-index: 10;
            border: 4px solid #e9eaee;
        }

        .group-slider-item {
            height: 200px;
            border-radius: 12px;
            overflow: hidden;
            // background: #000;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);

            img {
                position: absolute;
                top: 0;
                height: 100%;
                width: 100%;
                object-fit: cover;
                transition: transform 0.25s, filter 0.25s;
            }

            span {
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                right: 5px;
                top: 5px;
                border-radius: 5px;
                padding: 2px 7px 2px 9px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            h3 {
                background: rgba(0, 0, 0, 0.5);
            }

            &:hover {
                img {
                    transform: scale(1.05);
                    filter: brightness(0.8);
                    // opacity: 0.8;
                }
            }
        }

        &.compact {
            margin: 22px;

            .discover-more-btn {
                border-color: #fff;
            }
        }
    }
</style>
